<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="LabelProjects"
                :alvqa="alvqa"
            /> 
            <v-spacer /> 
            <v-col 
                cols="2"
                align-self="center"
            >
                <BaseButton 
                    label="lang_LABEL_PROJECTS_BUTTON_CAPTION_NEW_PROJECT"
                    :to="{ name: editForm, params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col> 
        </v-row>
    </div>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: 'LabelProjectsTopSlot',
    components: {
        BaseHeaderStats,
        BaseButton,
        ActionDropdown,
    },
    data() {
        return {
            editForm: 'LabelProjectsEdit',
            alvqa: 'label-projects'
        }
    },
    computed: {
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        },
    },
}
</script>